import css from './HeaderGeneral.module.css';

export function HeaderGeneral({ title, size }: { title: string; size?: 'sm' | 'md' | 'lg' }) {
  return (
    <div className={css.container} data-testid="header-general">
      <h1 className={`${css.title} ${size ? css[size] : ''}`}>{title}</h1>
    </div>
  );
}
